exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.presents{text-decoration-line:underline;text-decoration-color:#232323}p.description{font-weight:300;padding:5px 10px}.btn-selector{font-weight:500!important;font-size:2.5rem}.btn-selector,.diff_select{animation:fadeIn .5s ease-in 0s 1 normal;-webkit-animation:fadeIn 1s ease 0s 1 normal;border:.05em solid hsla(0,0%,59%,.3);margin:20px 0;text-align:center;padding:15px}.diff_select{background-color:hsla(0,0%,100%,.7)}", ""]);

// exports
